<template>
    <Dialog v-model:open="opened">
        <DialogContent v-if="confirmDialogData" class="sm:max-w-[425px]">
            <div
                class="gap-3 gap-y-4 sm:grid-cols-[48px_1fr] sm:gap-y-0 grid justify-center"
            >
                <div class="bg-white flex justify-center">
                    <ExclamationTriangleIcon
                        v-if="confirmDialogData.type === 'danger'"
                        class="h-12 w-12 rounded-md p-2 text-error-500 shadow-md"
                    />

                    <div
                        v-if="confirmDialogData.type === 'info'"
                        class="h-12 w-12 rounded-xl text-blue-500 flex items-center justify-center"
                    >
                        <Info :size="20"></Info>
                    </div>
                </div>
                <DialogHeader>
                    <DialogTitle>{{ confirmDialogData.header }}</DialogTitle>
                    <DialogDescription>
                        <p v-html="confirmDialogData.message"></p>
                    </DialogDescription>
                </DialogHeader>
            </div>
            <DialogFooter>
                <Button
                    ref="cancelButtonRef"
                    type="button"
                    variant="outline"
                    @click="onCancel"
                >
                    {{
                        confirmDialogData.cancel
                            ? confirmDialogData.cancel
                            : $t("cancel")
                    }}
                </Button>

                <Button
                    type="button"
                    :variant="
                        confirmDialogData.type === 'danger'
                            ? 'destructive'
                            : 'default'
                    "
                    @click="onSuccess"
                >
                    {{
                        confirmDialogData.confirm
                            ? confirmDialogData.confirm
                            : $t("confirm")
                    }}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { inject, ref } from "vue";
import useConfirm from "../composables/useConfirm";
import { Emitter } from "mitt";
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { Info } from "lucide-vue-next";

const { opened, confirmDialogData } = useConfirm();
const emitter = inject<Emitter<any>>("emitter");
const inputData = ref("");

const onCancel = () => {
    if (emitter === undefined) {
        return;
    }

    emitter.emit("dialog-canceled");
};

const onSuccess = () => {
    if (emitter === undefined) {
        return;
    }

    if (inputData.value === "") {
        emitter.emit("dialog-confirmed");
    } else {
        emitter.emit("dialog-confirmed", inputData.value);

        inputData.value = "";
    }
};
</script>
